import { ValueOf } from 'modules/Monitoring/types'

export const RelativeRoute = {
  Root: '/',
  Monitoring: 'monitoring',
  Ticket: 'ticket',
  Agent: 'agent',
} as const

export const Route = {
  ...RelativeRoute,
  Monitoring: `/${RelativeRoute.Monitoring}`,
  Ticket: `/${RelativeRoute.Monitoring}/${RelativeRoute.Ticket}`,
  Agent: `/${RelativeRoute.Monitoring}/${RelativeRoute.Agent}`,
} as const

export type RelativeRoute = ValueOf<typeof RelativeRoute>
export type Route = ValueOf<typeof Route>
